<template>
  <Row :gutter="16" style="min-height: 300px;">
    <Col span="24" v-if="bus.show_trend && loading">
      <div style="width: 100%;height: 300px;position: relative;">
        <Spin size="large" fix></Spin>
      </div>
    </Col>
    <more-info-trend
      v-else-if="bus.show_trend && trendList.length"
      ref="chart"
      :type="bus.trend_type"
      :dataSource="trendList"
    ></more-info-trend>
    <!-- <Col span="24" v-else-if="bus.show_trend">
      <div style="width: 100%;height: 300px;position: relative;">
        <caring-no-data />
      </div>
    </Col>-->
    <Col span="6">
      <el-button
        style="width: 100%;padding: 14px 20px;"
        type="primary"
        @click="add"
      >新增{{ bus.name }}</el-button>
      <div
        style="display:flex;flex-direction: column;overflow-y: auto;"
        :style="{ maxHeight: height - 151 + 'px' }"
      >
        <record-button
          v-if="curIndex === list.length"
          :active="true"
          :value="'新增' + bus.name"
          :show_delete="false"
        ></record-button>
        <record-button
          v-for="(u, i) in list"
          :value="u.alias || u.bind_name"
          :label="u.record_time ? u.record_time.slice(0, 16) : ''"
          :active="i === curIndex"
          :key="i"
          @click.native="edit(i)"
          @remove="remove(u, i)"
        />
      </div>
    </Col>
    <Col span="18">
      <more-info-card
        ref="moreInfoCard"
        v-if="curIndex !== -1"
        :bind_unique="curIndex === list.length ? '' : list[curIndex].bind_unique"
        :bind_code="curIndex === list.length ? bus.bind_code : list[curIndex].bind_code"
        :title="curIndex === list.length ? bus.name : (list[curIndex].alias || list[curIndex].bind_name || '')"
        :record_time="curIndex === list.length ? '' : list[curIndex].record_time"
        :medical_record_id="curIndex === list.length ? 'temp' : list[curIndex].medical_record_id"
        :params="params"
        @save="save"
        @cancel="cancel"
        @success="success"
      ></more-info-card>
      <div v-if="curIndex === -1 && !list.length" style="position: relative; height: 300px">
        <caring-no-data />
      </div>
    </Col>
  </Row>
</template>
<script>
import {
  getQuestionPatientRecordApi,
  deleteQuestionPatientRecordApi,
  getQuestionPersonRecordListApi,
  deleteQuestionPersonRecordApi,
  getModuleTrendApi,
} from '../../../api/config'
import moreInfoCard from './moreInfoCard.vue'
import recordButton from '../components/recordButton.vue'
import CaringNoData from '../../common/caringNoData.vue'
import moreInfoTrend from '../components/moreInfoTrend.vue'
export default {
  components: {
    moreInfoCard,
    moreInfoTrend,
    CaringNoData,
    recordButton,
  },
  props: {
    bus: {
      type: Object,
      default: () => ({}),
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['moreInfoType'],
  data() {
    return {
      list: [],
      curIndex: -1,
      height: '',
      init: false,
      trendList: [],
      loading: false,
    }
  },
  computed: {
    params() {
      if (this.moreInfoType === 'filter') {
        return {
          channel: '管理后台',
          institution_id: this.$store.state.shift.institution_id,
          disease_id: this.$store.state.shift.disease_id,
          dept_id: this.$store.state.shift.dept_id,
          team_ids: [this.$store.state.shift.team_ids],
          create_user_id: this.$store.state.user.user.id,
          user_id: this.info.user_id,
          permissions_type: 1,
          name: this.info.name,
          phone: this.info.phone,
          id_card: this.info.id_card,
          province: this.info.province,
          city: this.info.city,
          county: this.info.county,
          address: this.info.address,
          gender: this.info.gender,
          age: this.info.age,
        }
      } else {
        return {
          patient_id: this.info.patient_id,
          user_id: this.info.user_id,
          module_id: this.bus.module_id,
          name: this.info.name,
          module_name: this.bus.module_name,
          business_id: this.bus.id,
          business_name: this.bus.name,
          business_code: this.bus.code,
        }
      }
    },
  },
  watch: {
    bus() {
      this.curIndex = -1
      this.init = false
      this.getList()
      // if (this.bus.show_trend) {
      //   this.getTrend();
      // }
    },
  },
  created() {
    // this.getList();
  },
  mounted() {
    this.height = window.innerHeight - 126
    // this.getTrend();
  },
  methods: {
    add() {
      this.curIndex = this.list.length
    },
    edit(index) {
      this.curIndex = index
    },
    save() {
      this.$refs.moreInfoCard.submit()
    },
    removePerson(u, i) {
      const params = {
        person_id: this.info.id,
        questionnaire_id: u.bind_code,
        unique_id: u.bind_unique,
      }
      deleteQuestionPersonRecordApi(params).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          if (this.curIndex == i) {
            this.curIndex = -1
          }
          this.getList()
        }
      })
    },
    removePatient(u, i) {
      const params = {
        patient_id: this.info.patient_id,
        questionnaire_id: u.bind_code,
        unique_id: u.bind_unique,
      }
      deleteQuestionPatientRecordApi(params).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          if (this.curIndex == i) {
            this.curIndex = -1
          }
          this.getList()
        }
      })
    },
    remove(u, i) {
      if (this.moreInfoType === 'filter') {
        this.removePerson(u, i)
      } else {
        this.removePatient(u, i)
      }
    },
    cancel() {
      this.curIndex = -1
    },
    success() {
      this.curIndex = -1
      setTimeout(() => {
        this.getList()
      }, 1000)

      // if (this.bus.show_trend) {
      //   this.getTrend();
      // }
    },
    getPersonList() {
      const { id: person_id } = this.info
      const { bind_code: questionnaire_id } = this.bus
      getQuestionPersonRecordListApi({ person_id, questionnaire_id }).then(
        (res) => {
          if (res.code === 0) {
            this.list = res.data
            if (this.list.length && !this.init) {
              this.curIndex = 0
            }
            this.init = true
            if (this.bus.code === 'appoint') {
              this.$emit('save', res.data)
            }
            if (this.list.length) {
              this.getTrend()
            }
          } else {
            this.$Message.error(res.message)
          }
        }
      )
    },
    getPatientList() {
      const { patient_id } = this.info
      const { bind_code: questionnaire_id } = this.bus
      getQuestionPatientRecordApi({ patient_id, questionnaire_id }).then(
        (res) => {
          if (res.code === 0) {
            this.list = res.data
            if (this.list.length && !this.init) {
              this.curIndex = 0
            }
            this.init = true
            if (this.bus.code === 'appoint') {
              this.$emit('save', res.data)
            }
            if (this.list.length) {
              this.getTrend()
            }
          } else {
            this.$Message.error(res.message)
          }
        }
      )
    },
    getList() {
      if (!this.bus.bind_code) return
      if (this.moreInfoType === 'filter') {
        this.getPersonList()
      } else {
        this.getPatientList()
      }
    },
    getTrend() {
      if (!this.bus.show_trend) return
      this.loading = true
      let p = {
        type: this.moreInfoType == 'filter' ? 0 : 1,
        trend_type: this.bus.trend_type,
        bind_code: this.bus.bind_code,
        trend_code:
          this.bus.trend_type === 0 ? this.bus.bind_code : this.bus.trend_code,
      }
      if (this.moreInfoType == 'filter') {
        p.person_id = this.info.id
      } else {
        p.patient_id = this.info.patient_id
      }
      getModuleTrendApi(p)
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.trendList = res.data
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
